import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { withGrid } from "../../hoc/WithGrid/WithGrid";
import remoteAssetUrl from "../../lib/remote-asset-url";

function Image({
    image,
    alt,
    title,
    children,
    imageClass,
    mediaDescription,
    objectPosition = "right top",
    objectFit = "scale-down",
    ...other
}) {
    if (!image) {
        console.warn(`The image has no data.`);
        return null;
    }

    const imageAlt = alt || image.alt || "";
    const imageTitle = title || image.title || "";

    if (!image.gatsbyImageData && !image.url) {
        console.warn(
            `The image ${image?.originalId} has neither gatsbyImageData nor URL defined.`
        );
        return null;
    }

    const imageData = getImage(image.gatsbyImageData);

    return (
        <>
            {imageData ? (
                <GatsbyImage
                    role="img"
                    image={remoteAssetUrl(imageData, image.customData)}
                    imgClassName={imageClass}
                    imgStyle={{transition: 'none'}}
                    alt={imageAlt}
                    title={imageTitle}
                    objectPosition={objectPosition}
                    objectFit={objectFit}
                    {...other}
                >
                    {children}
                </GatsbyImage>
            ) : (
                <>
                    {image.url && (
                        <img
                            src={remoteAssetUrl(image.url, image.customData)}
                            className={imageClass}
                            alt={imageAlt || ""}
                            {...other}
                        >
                            {children}
                        </img>
                    )}
                </>
            )}
            {mediaDescription && <span>{mediaDescription}</span>}
        </>
    );
}

const ImageWithGrid = withGrid(Image);

export { Image, ImageWithGrid };
